<template>
  <div class="container">
    <div class="pccontent" v-if="!isMobile">
      <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :show-close="showClose" :close-image="closeBtnImg" :showSuccess="showSuccess" :error-msg="errorMsg" @close="closeDialog" />
      <sys-loading :loading="loading" />
      <div class="title-box">
        <img class="img-box" src="../assets/newldp/logo.png" alt="8day - 01">
      </div>

      <swiper class="swiper-banner" :options="swiperOptions">
        <swiper-slide>
          <img src="../assets/newldp/out1.png" alt="8day - 02" width="100%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/newldp/out2.png" alt="8day - 03" width="100%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/newldp/out3.png" alt="8day - 04" width="100%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/newldp/out4.png" alt="8day - 05" width="100%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/newldp/out5.png" alt="8day - 06" width="100%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/newldp/out6.png" alt="8day - 07" width="100%" />
        </swiper-slide>
      </swiper>

      <div class="content-box">
        <div class="title-img">
          <div class="right-side">
            <div class="left" @click="logindialogVisible=true" @mouseover="activeName='first'">
              <img src="../assets/newldp/registeractive.png" v-if="activeName=='first'" />
              <img src="../assets/newldp/register.png" alt="8day - 08" v-else />
            </div>
            <div class="right" @click="logindialogVisible=true" @mouseover="activeName='second'">
              <img src="../assets/newldp/login.png" v-if="activeName=='first'" />
              <img src="../assets/newldp/loginactive.png" alt="8day - 09" v-else />
            </div>
          </div>
        </div>
        <div class="banner-list">
          <img src="../assets/newldp/banner1.png" alt="8day - 10">
          <img src="../assets/newldp/banner2.png" alt="8day - 11">
          <img src="../assets/newldp/banner3.png" alt="8day - 12">
          <img src="../assets/newldp/banner4.png" alt="8day - 13">
          <img src="../assets/newldp/banner5.png" alt="8day - 13">
          <img src="../assets/newldp/banner6.png" alt="8day - 14">
          <img src="../assets/newldp/banner7.png" alt="8day - 15">
          <img src="../assets/newldp/banner8.png" alt="8day - 16">
        </div>
        <div class="banner-text-box">
          <h1>8DAY - 8DAY TOP 10 NHÀ CÁI UY TÍN XANH CHÍN NHẤT NĂM 2024</h1>
          <span>8day</span> thương hiệu trang nhà cái "gây bão" trong thế giới game giải trí online đổi thưởng và casino trực tuyến, không chỉ là một cổng game đẳng cấp mà còn là điểm đến của sự đổi mới và sáng tạo. 8day với những điểm độc đáo, những chương chình khuyến mãi bùng nổ đầy hấp dẫn mà khó có trang nhà cái nào có được là những gì <span>8day</span> mang đến cho người chơi trong 2024.
        </div>
        <img src="../assets/newldp/bannercenter.png" class="banner-center" alt="8day - 17">
        <div class="rule-box">
          <h2 class="big-title-new">DAY CÓ NHỮNG ƯU ĐIỂM GÌ ?</h2>
          <div>
            <span>8day</span> luôn đưa chất lượng dịch vụ lên hàng đầu là kim chỉ nam hoạt động và đáp ứng, thỏa mãn các nhu cầu nhỏ nhất của người chơi. Ưu điểm của 8day được cộng đồng gamebler tin tưởng đánh giá cao, có thể kể đến như:
          </div>
          <div>
            <h3 class="h1">8day Với Hệ Thống An Toàn và Bảo Mật Tuyệt Đối</h3>
            <ul>
              <li><span>8day</span> chúng tôi cam kết tạo ra sân chơi công bằng, công chính, công khai cho người dùng. </li>
              <li>Đến với hệ sinh thái 8day.com bạn sẽ được trải nghiệm sự phục vụ tận tâm và chuyên nghiệp nhất tại Việt Nam - Châu Á.</li>
              <li>Hệ thống bảo mật tại 8day đặt sự an toàn thông tin của người chơi lên hàng đầu với công nghệ mã hóa SSL 128bit và hệ thống quản lý bảo mật nghiêm ngặt nhất nhằm đảm
                <div>bảo thông tin cá nhân và giao dịch tài khoản một cách bảo mật tuyệt đối.</div> 
              </li>
            </ul>
          </div>

          <div>
            <h3 class="h1">8day Kho Game Khổng Lồ hơn 15.000 Đầu Game</h3>
            <ul>
              <li>8day luôn tự hào là thương hiệu nhà cái cung cấp ra thị trường da dạng game giải trí đặc sắc nhất, đồng thời 8day mang đến cho bạn không gian casino trực tuyến với đầy đủ
                <div>các thể loại như Baccarat , Rổng Hổ, Blackjack, Roulette, Tài Xỉu… Bắn cá, Slotgame, Xổ số lô đề, Đá gà, Cá độ bóng đá cùng cá cược các môn thể thao…</div>
              </li>
            </ul>
          </div>

          <h3 class="big-title">8DAY DỊCH VỤ HỖ TRỢ CHUYÊN NGHIỆP</h3>
          <div>
            <span>8day</span> cung cấp dịch vụ khách hàng 24/7 trực tuyến chăm sóc nhiệt tình, tận tâm  mọi thắc mắc hay vấn đề của quý hội viên sẽ được giải quyết một cách nhanh chóng và chuyên
            <div>nghiệp.</div>
          </div>

          <img class="img-1" src="../assets/newldp/ruleboximg1.png" alt="8day - 18">

          <div>
            <h3 class="h1">Mọi Giao Dịch Tại 8day An Toàn Và Uy Tín</h3>
            <div>Tại <span>8day</span> tất cả các giao dịch nạp và rút tiền vô cùng đơn giản, nhanh gọn tiện lợi hơn. Với đa dạng linh hoạt các phương thức nạp tiền và rút tiền, quý hội viên 8day có thể linh
              <div> hoạt chọn lựa giao dịch mọi lúc mọi nơi mà không gặp khó khăn.</div>
            </div>
          </div>

          <div>
            <h4 class="h1">Nạp Tiền 8day:</h4>
            <ul>
              <li class="ano-li">Nạp qua ngân hàng: hỗ trợ tất cả các ngân hàng hiện có trong lãnh thổ Việt Nam</li>
              <li class="ano-li">Nạp qua thẻ cào: hỗ trợ toàn bộ các nhà mạng tại Việt Nam như : Mobifone, Viettel, Vietnamobile, Vinaphone, Zing (mớii)</li>
              <li class="ano-li">Nạp ví điện tử Viettelpay , Zalopay, Momo</li>
              <li class="ano-li">Nạp 1Pay, 24hpay</li>
              <li class="ano-li">Nạp codepay…</li>
              <li class="ano-li">Nạp tiền ảo: 8day hỗ trợ nạp ví tiền ảo USDT mã TRC20</li>
            </ul>
          </div>

          <div>Bước 1: Người chơi nhấn vào nút trên thanh Nạp tiền, tìm sau đó nhấp chọn cổng thanh toán mà mình muốn.</div>

          <div>Bước 2: Thực hiện tuần tự kiểm tra từng bước tùy vào từng hình thức nạp tiền cụ thể. Hầu hết các hội viên sẽ sử dụng ứng dụng ngân hàng, ví điện tử hoặc ứng dụng tài chính
            <div> thông minh để tiến hành chuyển khoản theo thông tin hiển thị trên màn hình.</div>
          </div>

          <div>Bước 3: Sau khi hội viên hoàn tất các bước thao tác giao dịch thành công, hệ thống sẽ tự động xác minh và xử lý lệnh nạp tiền lên tài khoản game trong vòng 30 giây.</div>

          <img class="img-1" src="../assets/newldp/ruleboximg2.png" alt="8day - 19">

          <div>
            <h4 class="h1">Rút Tiền 8day:</h4>
            <div>Đơn giản nhanh chóng chỉ 30s tiền về tài khoản:</div>
            <ul>
              <li class="ano-li">Rút về tài khoản ngân hàng: Phương thức nhanh chóng, dễ dàng thực hiện rút tiền tại tài khoản game về tài khoản của bạn.</li>
              <li class="ano-li">Rút về ví tiền ảo: 8day hiện tại hỗ trợ rút về ví tiền ảo đồng USDT mã TRC20</li>
            </ul>
          </div>

          <div>
            Bước 1: Người chơi nhấn vào mục Rút tiền, chọn một trong ba phương án mà 8day hỗ trợ là Ngân hàng, Thẻ cào và Tiền ảo USDT...
          </div>

          <div>
            Bước 2: Đối với rút tiền qua Ngân hàng, anh em điền đầy đủ thông tin Tên ngân hàng, Số tài khoản, Số tiền cần rút và Tên tài khoản.
          </div>

          <div>
            Bước 3: Anh em kiểm tra lại một lần nữa thông tin vừa cung cấp, nhấn nút Rút tiền. Cuối cùng, hệ thống sẽ tự động xác minh thông tin chính chủ và thực hiện ngay giao dịch
            <div>trong 01 phút.</div>
          </div>

          <img class="img-1" src="../assets/newldp/ruleboximg3.png" alt="8day - 20">

          <div>
            <h3 class="h1">
              8day Nhận Được Sự Tin Tưởng Của Cộng Đồng Người Chơi
            </h3>
            8day được cộng đồng gambler bình chọn là top 10 trang nhà cái uy tín chất lượng đẳng cấp năm 2024, 8day đang dần nâng cấp thay đổi mạnh mẽ phát triển hướng tới một
            <div>không gian giải trí ưu việt nhất với cộng đồng bet thủ</div>
          </div>

          <div class="end-link">
            * Tìm kiếm trang chủ 8day với các hashtag:
            <div> #8day #nhacai8day #8day80k #linkvao8day #trangchu8day #linktruycap8day</div>
          </div>

        </div>
      </div>

      <div class="footer-1">
        <div class="loginbtn" @click="logindialogVisible = true"></div>
      </div>
      <img src="../assets/newldp/footer2.png" class="footer" alt="8day - 21">

      <!--
      <div class="home-download">
        <div class="phone">
          <div class="first"></div>
          <div class="second"></div>
          <div class="third"></div>
          <div class="fourth"></div>
          <div class="fifth"></div>
          <div class="sixth"></div>
        </div>
      </div> -->

      <el-dialog class="login-box" title="" :show-close="false" :visible.sync="logindialogVisible">
        <div class="form-content">
          <img class="dialogtitle" src="../assets/newldp/dialogtitle.png" alt="8day - 22">
          <div class="tabs">
            <div class="left" @click="activeName='first'">
              <img src="../assets/newldp/registeractive.png" alt="8day - 23" v-if="activeName=='first'" />
              <img src="../assets/newldp/register.png" alt="8day - 24" v-else />
            </div>
            <div class="right" @click="activeName='second'">
              <img src="../assets/newldp/login.png" alt="8day - 25" v-if="activeName=='first'" />
              <img src="../assets/newldp/loginactive.png" alt="8day - 26" v-else />
            </div>
          </div>
          <div class="form">
            <template v-if="activeName=='first'">
              <el-form :model="regform" ref="regform" :rules="regrules" class="inputs">
                <el-form-item prop="userName">
                  <div class="form-input">
                    <input v-model="regform.userName" @input="regform.userName = regform.userName.replace(/[^\w]/gi, '')" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
                  </div>
                </el-form-item>
                <el-form-item prop="pass">
                  <div class="form-input">
                    <input v-model="regform.pass" type="password" placeholder="Mật khẩu" maxlength="10" />
                  </div>
                </el-form-item>
                <el-form-item prop="checkPass">
                  <div class="form-input">
                    <input v-model="regform.checkPass" type="password" autocomplete="new-password" placeholder="Nhập lại mật khẩu" />
                  </div>
                </el-form-item>
                <el-form-item prop="verificationCode">
                  <div class="form-input verificationCode">
                    <input v-model="regform.verificationCode" maxlength="4" autocomplete="new-password" placeholder="Mã xác minh" />
                  </div>
                  <div class="codeImg">
                    <span @click="getVerify" v-if="codeImg" class="validateCode">
                      <img class="img" :src="codeImg" alt="8day - 27" />
                    </span>
                  </div>
                </el-form-item>
                <el-form-item prop="phonenumber">
                  <div class="form-input">
                    <input v-model="regform.phonenumber" type="text" placeholder="Số điện thoại" />
                  </div>
                </el-form-item>
              </el-form>
              <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" @cb="register" :vstyle="{ bottom: '30px', position: 'absolute' }" :nativeButton="{
                  width: '250px',
                  height: '70px'
                }">
                <div class="submitBtn" @click="submitAction('regform',1)"> </div>
              </v-captcha>
            </template>
            <template v-else>
              <el-form :model="loginform" ref="loginform" :rules="loginrules" class="inputs">
                <el-form-item prop="userName">
                  <div class="form-input">
                    <input v-model="loginform.userName" @input="loginform.userName = loginform.userName.replace(/[^\w]/gi, '')" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
                  </div>
                </el-form-item>
                <el-form-item prop="pass">
                  <div class="form-input">
                    <input v-model="loginform.pass" type="password" placeholder="Mật khẩu" maxlength="10" />
                  </div>
                </el-form-item>
              </el-form>
              <div class="submitBtn login" @click="submitAction('loginform',2)">
              </div>
            </template>
          </div>

        </div>
      </el-dialog>
      <div class="fixed-bottom-left" v-if="showturntable">
        <img src="../assets/newldp/turntable.png" @click="logindialogVisible = true" alt="8day - 28" />
        <i class="el-dialog__close el-icon el-icon-close" @click="showturntable = false"></i>
      </div>

    </div>
    <div class="root" v-if="isMobile">

      <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :show-close="showClose" :close-image="closeBtnImg" :showSuccess="showSuccess" :error-msg="errorMsg" @close="closeDialog" />
      <sys-loading :loading="loading" />
      <div class="title-box" @click="showForm = false">
        <img class="img-box" src="../assets/newldp/logo.png" alt="8day - 01">
      </div>
      <swiper class="swiper-banner" :options="swiperOptions">
        <swiper-slide>
          <img src="../assets/newldp/h5out1.png" alt="8day - 02" width="100%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/newldp/h5out2.png" alt="8day - 03" width="100%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/newldp/h5out3.png" alt="8day - 04" width="100%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/newldp/h5out4.png" alt="8day - 05" width="100%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/newldp/h5out5.png" alt="8day - 06" width="100%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/newldp/out6.png" alt="8day - 07" width="100%" />
        </swiper-slide>
      </swiper>

      <div class="content-box" v-if="!showForm">
        <div class="top-side">
          <div class="left" @click="showForm=true" @mouseover="activeName='first'">
            <img src="../assets/newldp/registeractive.png" alt="8day - 08" v-if="activeName=='first'" />
            <img src="../assets/newldp/register.png" alt="8day - 09" v-else />
          </div>
          <div class="right" @click="showForm=true" @mouseover="activeName='second'">
            <img src="../assets/newldp/login.png" alt="8day - 10" v-if="activeName=='first'" />
            <img src="../assets/newldp/loginactive.png" alt="8day - 11" v-else />
          </div>
        </div>
        <img class="title-img" alt="8day - 12" src="../assets/newldp/boxtop.png" />
        <div class="banner-list">
          <img src="../assets/newldp/banner1.png" alt="8day - 13">
          <img src="../assets/newldp/banner2.png" alt="8day - 14">
          <img src="../assets/newldp/banner3.png" alt="8day - 15">
          <img src="../assets/newldp/banner4.png" alt="8day - 16">
          <img src="../assets/newldp/banner5.png" alt="8day - 17">
          <img src="../assets/newldp/banner6.png" alt="8day - 18">
          <img src="../assets/newldp/banner7.png" alt="8day - 19">
          <img src="../assets/newldp/banner8.png" alt="8day - 20">
        </div>
        <div class="banner-text-box">
          <h1>8DAY - 8DAY TOP 10 NHÀ CÁI UY TÍN XANH CHÍN NHẤT NĂM 2024</h1>
          <span>8day</span> thương hiệu trang nhà cái "gây bão" trong thế giới game giải trí online đổi thưởng và casino trực tuyến, không chỉ là một cổng game đẳng cấp mà còn là điểm đến của sự đổi mới và sáng tạo. 8day với những điểm độc đáo, những chương chình khuyến mãi bùng nổ đầy hấp dẫn mà khó có trang nhà cái nào có được là những gì <span>8day</span> mang đến cho người chơi trong 2024.
        </div>
        <img src="../assets/newldp/bannercenter.png" class="banner-center" alt="8day - 21">
        <div class="rule-box">
          <h2 class="big-title">8DAY CÓ NHỮNG ƯU ĐIỂM GÌ?</h2>
          <div>
            <span>8day</span> luôn đưa chất lượng dịch vụ lên hàng đầu là kim chỉ nam hoạt động và đáp ứng, thỏa mãn các nhu cầu nhỏ nhất của người chơi. Ưu điểm của 8day được cộng đồng gamebler tin tưởng đánh giá cao, có thể kể đến như:
          </div>
          <div>
            <h3 class="h1">8day Với Hệ Thống An Toàn và Bảo Mật Tuyệt Đối</h3>
            <ul>
              <li><span>8day</span> chúng tôi cam kết tạo ra sân chơi công bằng, công chính, công khai cho người dùng. </li>
              <li>Đến với hệ sinh thái 8day.com bạn sẽ được trải nghiệm sự phục vụ tận tâm và chuyên nghiệp nhất tại Việt Nam - Châu Á.</li>
              <li>Hệ thống bảo mật tại 8day đặt sự an toàn thông tin của người chơi lên hàng đầu với công nghệ mã hóa SSL 128bit và hệ thống quản lý bảo mật nghiêm ngặt nhất nhằm đảm
                <div>bảo thông tin cá nhân và giao dịch tài khoản một cách bảo mật tuyệt đối.</div> 
              </li>
            </ul>
          </div>

          <div>
            <h3 class="h1">8day Kho Game Khổng Lồ hơn 15.000 Đầu Game</h3>
            <ul>
              <li>8day luôn tự hào là thương hiệu nhà cái cung cấp ra thị trường da dạng game giải trí đặc sắc nhất, đồng thời 8day mang đến cho bạn không gian casino trực tuyến với đầy đủ
                <div>các thể loại như Baccarat , Rổng Hổ, Blackjack, Roulette, Tài Xỉu… Bắn cá, Slotgame, Xổ số lô đề, Đá gà, Cá độ bóng đá cùng cá cược các môn thể thao…</div>
              </li>
            </ul>
          </div>

          <h3 class="big-title">8DAY DỊCH VỤ HỖ TRỢ CHUYÊN NGHIỆP</h3>
          <div>
            <span>8day</span> cung cấp dịch vụ khách hàng 24/7 trực tuyến chăm sóc nhiệt tình, tận tâm  mọi thắc mắc hay vấn đề của quý hội viên sẽ được giải quyết một cách nhanh chóng và chuyên
            <div>nghiệp.</div>
          </div>

          <img class="img-1" src="../assets/newldp/ruleboximg1.png" alt="8day - 22">

          <div>
            <h3 class="h1">Mọi Giao Dịch Tại 8day An Toàn Và Uy Tín</h3>
            <div>Tại <span>8day</span> tất cả các giao dịch nạp và rút tiền vô cùng đơn giản, nhanh gọn tiện lợi hơn. Với đa dạng linh hoạt các phương thức nạp tiền và rút tiền, quý hội viên 8day có thể linh
              <div> hoạt chọn lựa giao dịch mọi lúc mọi nơi mà không gặp khó khăn.</div>
            </div>
          </div>

          <div>
            <h4 class="h1">Nạp Tiền 8day:</h4>
            <ul>
              <li class="ano-li">Nạp qua ngân hàng: hỗ trợ tất cả các ngân hàng hiện có trong lãnh thổ Việt Nam</li>
              <li class="ano-li">Nạp qua thẻ cào: hỗ trợ toàn bộ các nhà mạng tại Việt Nam như : Mobifone, Viettel, Vietnamobile, Vinaphone, Zing (mớii)</li>
              <li class="ano-li">Nạp ví điện tử Viettelpay , Zalopay, Momo</li>
              <li class="ano-li">Nạp 1Pay, 24hpay</li>
              <li class="ano-li">Nạp codepay…</li>
              <li class="ano-li">Nạp tiền ảo: 8day hỗ trợ nạp ví tiền ảo USDT mã TRC20</li>
            </ul>
          </div>

          <div>Bước 1: Người chơi nhấn vào nút trên thanh Nạp tiền, tìm sau đó nhấp chọn cổng thanh toán mà mình muốn.</div>

          <div>Bước 2: Thực hiện tuần tự kiểm tra từng bước tùy vào từng hình thức nạp tiền cụ thể. Hầu hết các hội viên sẽ sử dụng ứng dụng ngân hàng, ví điện tử hoặc ứng dụng tài chính
            <div> thông minh để tiến hành chuyển khoản theo thông tin hiển thị trên màn hình.</div>
          </div>

          <div>Bước 3: Sau khi hội viên hoàn tất các bước thao tác giao dịch thành công, hệ thống sẽ tự động xác minh và xử lý lệnh nạp tiền lên tài khoản game trong vòng 30 giây.</div>

          <img class="img-1" src="../assets/newldp/ruleboximg2.png" alt="8day - 23">

          <div>
            <h4 class="h1">Rút Tiền 8day:</h4>
            <div>Đơn giản nhanh chóng chỉ 30s tiền về tài khoản:</div>
            <ul>
              <li class="ano-li">Rút về tài khoản ngân hàng: Phương thức nhanh chóng, dễ dàng thực hiện rút tiền tại tài khoản game về tài khoản của bạn.</li>
              <li class="ano-li">Rút về ví tiền ảo: 8day hiện tại hỗ trợ rút về ví tiền ảo đồng USDT mã TRC20</li>
            </ul>
          </div>

          <div>
            Bước 1: Người chơi nhấn vào mục Rút tiền, chọn một trong ba phương án mà 8day hỗ trợ là Ngân hàng, Thẻ cào và Tiền ảo USDT...
          </div>

          <div>
            Bước 2: Đối với rút tiền qua Ngân hàng, anh em điền đầy đủ thông tin Tên ngân hàng, Số tài khoản, Số tiền cần rút và Tên tài khoản.
          </div>

          <div>
            Bước 3: Anh em kiểm tra lại một lần nữa thông tin vừa cung cấp, nhấn nút Rút tiền. Cuối cùng, hệ thống sẽ tự động xác minh thông tin chính chủ và thực hiện ngay giao dịch
            <div>trong 01 phút.</div>
          </div>

          <img class="img-1" src="../assets/newldp/ruleboximg3.png" alt="8day - 24">

          <div>
            <h3 class="h1">
              8day Nhận Được Sự Tin Tưởng Của Cộng Đồng Người Chơi
            </h3>
            8day được cộng đồng gambler bình chọn là top 10 trang nhà cái uy tín chất lượng đẳng cấp năm 2024, 8day đang dần nâng cấp thay đổi mạnh mẽ phát triển hướng tới một
            <div>không gian giải trí ưu việt nhất với cộng đồng bet thủ</div>
          </div>

          <div class="end-link">
            * Tìm kiếm trang chủ 8day với các hashtag:
            <div> #8day #nhacai8day #8day80k #linkvao8day #trangchu8day #linktruycap8day</div>
          </div>

        </div>
      </div>

      <div class="form-content" v-if="showForm">
        <img class="dialogtitle" src="../assets/newldp/dialogtitle.png" alt="8day - 25">
        <div class="tabs">
          <div class="left" @click="activeName='first'">
            <img src="../assets/newldp/registeractive.png" alt="8day - 26" v-if="activeName=='first'" />
            <img src="../assets/newldp/register.png" alt="8day - 27" v-else />
          </div>
          <div class="right" @click="activeName='second'">
            <img src="../assets/newldp/login.png" alt="8day - 28" v-if="activeName=='first'" />
            <img src="../assets/newldp/loginactive.png" alt="8day - 29" v-else />
          </div>
        </div>
        <div class="form">
          <template v-if="activeName=='first'">
            <el-form :model="regform" ref="regform" :rules="regrules" class="inputs">
              <el-form-item prop="userName">
                <div class="form-input">
                  <input v-model="regform.userName" @input="regform.userName = regform.userName.replace(/[^\w]/gi, '')" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
                </div>
              </el-form-item>
              <el-form-item prop="pass">
                <div class="form-input">
                  <input v-model="regform.pass" type="password" placeholder="Mật khẩu" maxlength="10" />
                </div>
              </el-form-item>
              <el-form-item prop="checkPass">
                <div class="form-input">
                  <input v-model="regform.checkPass" type="password" autocomplete="new-password" placeholder="Nhập lại mật khẩu" />
                </div>
              </el-form-item>
              <el-form-item prop="verificationCode">
                <div class="form-input verificationCode">
                  <input v-model="regform.verificationCode" maxlength="4" autocomplete="new-password" placeholder="Mã xác minh" />
                </div>
                <div class="codeImg">
                  <span @click="getVerify" v-if="codeImg" class="validateCode">
                    <img class="img" :src="codeImg" alt="8day - 30" />
                  </span>
                </div>
              </el-form-item>
              <el-form-item prop="phonenumber">
                <div class="form-input">
                  <input v-model="regform.phonenumber" type="text" placeholder="Số điện thoại" />
                </div>
              </el-form-item>
            </el-form>
            <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" @cb="register" :vstyle="{ bottom: '30px', position: 'absolute' }" :nativeButton="{
                  width: '250px',
                  height: '70px'
                }">
              <div class="submitBtn" @click="submitAction('regform',1)"> </div>
            </v-captcha>
          </template>
          <template v-else>
            <el-form :model="loginform" ref="loginform" :rules="loginrules" class="inputs">
              <el-form-item prop="userName">
                <div class="form-input">
                  <input v-model="loginform.userName" @input="loginform.userName = loginform.userName.replace(/[^\w]/gi, '')" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
                </div>
              </el-form-item>
              <el-form-item prop="pass">
                <div class="form-input">
                  <input v-model="loginform.pass" type="password" placeholder="Mật khẩu" maxlength="10" />
                </div>
              </el-form-item>
            </el-form>
            <div class="submitBtn login" @click="submitAction('loginform',2)">
            </div>
          </template>
        </div>
      </div>

      <template v-if="!showForm">
        <div class="footer-1">
          <div class="loginbtn" @click="showForm = true"></div>
        </div>
        <img src="../assets/newldp/h5footer2.png" class="footer" alt="8day - 31">
      </template>

      <div class="fixed-bottom-left" v-if="showturntable">
        <img src="../assets/newldp/turntable.png" @click="showForm = true" alt="8day - 32" />
        <i class="el-dialog__close el-icon el-icon-close" @click="showturntable = facebook"></i>
      </div>

      <div class="fixed-bottom-right">
        <img src="../assets/newldp/Telegram.png" alt="Telegram">
        <img src="../assets/newldp/Zalo.png" alt="Zalo">
        <a href="https://www.facebook.com/8dayclub"> <img src="../assets/newldp/Facebook.png" alt="Facebook"></a>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import md5 from "js-md5";
import {
  FORM_VALID_MESSAGE,
  CONTRACTS,
  DOMAIN_AGENT_CODE
} from "../utils/constant";
import { userRegister, userLogin, createCustomer, getCode, userGetGoPageUrl } from "../utils/request";
import {
  encodePlatformUrl,
  isMobile,
} from "../utils/tools";
import { captcha } from "@/mixins/captcha";
export default {
  name: "LDP",
  mixins: [captcha],
  components: { swiper, swiperSlide },
  data() {
    var validateName = (rule, value, callback) => {
      if (value === "" || !value) {
        callback(new Error("Tên đăng nhập không được để trống"));
      } else {
        console.log('value', value);
        if (value.length < 4) {
          callback(new Error("4 - 20 ký tự bao gồm số và chữ"));
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "" || String(value).length < 6) {
        callback(new Error("6 - 15 ký tự bao gồm số và chữ"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "" || String(value).length < 6) {
        callback(new Error("6 - 15 ký tự bao gồm số và chữ"));
      } else if (value !== this.regform.pass) {
        callback(new Error("Xác nhận mật khẩu không trùng khớp!"));
      } else {
        callback();
      }
    };
    var validateverificationCode = (rule, value, callback) => {
      console.log('......validateverificationCode', value)
      if (value === "" || value == undefined) {
        callback(new Error("Mã xác minh không được để trống"));
      } else {
        callback();
      }
    };
    return {
      showturntable: true,
      showForm: false,
      logindialogVisible: false,
      showClose: false,
      showSuccess: false,
      regform: {
        userName: "",
        pass: "",
        checkPass: "",
        verificationCode: "",
        phonenumber: ''
      },
      regrules: {
        userName: {
          validator: validateName,
          trigger: "change"
        },
        pass: {
          validator: validatePass,
          trigger: "change"
        },
        checkPass: {
          validator: validatePass2,
          trigger: "change"
        },
        verificationCode: {
          validator: validateverificationCode,
          trigger: "blur"
        },
      },
      loginform: {
        userName: "",
        pass: ""
      },
      loginrules: {
        userName: {
          validator: validateName,
          trigger: "change"
        },
        pass: {
          validator: validatePass,
          trigger: "change"
        },
      },
      swiperOptionThumbs: {
        loop: true,
        speed: 1000,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      activeName: 'first',
      activeName2: 'first',
      isMobile: isMobile(),
      loading: false,
      dialogVisible: false,
      dialogBgi: require("../assets/Ldp/bgi-dialog.png"),
      closeBtnImg: require("../assets/sinh/icon-close.png"),
      contacts: CONTRACTS,
      swiperOptions: {
        speed: 1000,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        effect: "slide",
        navigation: {
          nextEl: ".next-btn",
          prevEl: ".prev-btn"
        }
      },
      errorMsg: {
        title: "",
        content: ""
      },
      codeImg: '',
      goPageUrl: ''
    };
  },
  mounted() {
    userGetGoPageUrl({}).then(res => {
      console.log();
      const list = res.body.list;
      const randomIndex = Math.floor(Math.random() * list.length);
      this.goPageUrl = list[randomIndex].api_url;
      console.log(this.goPageUrl);
    });
    document.querySelector('html').style.fontSize = '13.5vw'
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    if (this.isMobile) {
      //   require('@/utils/rem.js')
      document.querySelector('html').style.fontSize = '13.34vw'
    } else {
      document.querySelector('html').style.fontSize = '13.5vw'
    }
    this.getVerify();
  },
  methods: {
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    submitAction(formName, type) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.loading = true;
          // 登陆
          if (type == 2) {
            let temp = Object.assign({}, that[formName]);
            let params = {
              userName: temp.userName,
              password: md5(temp.pass)
            };
            that.login(params);
          } else {
            that.handleCheck(that.register);
            // that.register()
          }
        }
      });
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            this.showSuccess = true
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password,
                this.goPageUrl
              );
            }, 5000);
          } else {
            this.showSuccess = false
            this.showClose = true
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      this.handleConfirm()
    },
    handleConfirm() {
      // params.userName = params.userName.toLowerCase();
      // params.password = md5(params.password);
      const params = {
        userName: this.regform.userName.toLowerCase().replace(/\s+/g, ""),
        password: md5(this.regform.checkPass.replace(/\s+/g, "")),
        verificationCode: this.regform.verificationCode,
        by: 1,
        inviteCode: (this.inviteCodeObj && this.inviteCodeObj[location.host]) || DOMAIN_AGENT_CODE[location.host] || "",
        link: process.env.NODE_ENV === "development" ? "8day.com" : window.location.host.replace("www.", "")
      };
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.body.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            this.showSuccess = true
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password,
                this.goPageUrl
              );
            }, 5000);
          } else {
            this.getVerify();
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.body.msg
            );
            this.showSuccess = false
            this.showClose = true
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .login-box .el-dialog {
  background-color: transparent;
  width: 2.696581rem;
}
/deep/ .el-carousel__arrow {
  display: none !important;
}
/deep/ .el-carousel__indicators--horizontal {
  display: none;
}
.gallery-thumbs {
  box-sizing: border-box;
  padding: 10px 0px;
  width: 864px;
  margin-left: 2px;
  .swiper-button-next {
    right: 0px;
  }
  .swiper-button-prev {
    left: 0px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    width: 45px;
    text-align: center;
    height: 0;
    top: 26%;
    div {
      margin-top: 31px;
      height: 45px;
      border-radius: 50%;
      img {
        margin: 7px 0 0 2px;
        width: 30px;
      }
    }
  }
}
.gallery-thumbs .swiper-slide {
  height: 80px;
  // opacity: 0.4;
}

.el-carousel {
  padding-top: 47px;
}
.el-carousel,
.el-carousel__item {
  width: 320px;
  height: 320px;
}
.el-carousel__container img {
  width: 320px;
  height: 320px;
}
@media only screen and (min-width: 1420px) and (max-width: 1680px) {
  .container .content .submitBtn,
  .container .content .tags .tag {
    font-size: 24px !important;
  }
}

.container {
  .hide {
    display: none;
  }
  ::-ms-input-placeholder {
    font-size: 24px;
    color: #ffffff;
  }

  ::-webkit-input-placeholder {
    font-size: 24px;
    color: #ffffff;
  }

  // PC端
  .pccontent {
    height: 100%;
    background: #010508 url("../assets/newldp/pcBg.png") no-repeat center/100%;
    .fixed-bottom-left {
      position: fixed;
      bottom: 0;
      width: 1.596581rem;
      cursor: pointer;
      left: 0;
      z-index: 1;
      img {
        width: 100%;
      }
      i {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 0.10547rem;
        color: #fff;
      }
    }
    .title-box {
      width: 100%;
      height: 0.37037rem;
      display: flex;
      justify-content: center;
      align-items: center;
      .img-box {
        width: 0.574074rem;
      }
    }
    .swiper-banner {
      width: 100%;
      height: 1.851852rem;
    }
    .content-box {
      width: 6.871795rem;
      margin: 0 auto;
      text-align: center;
      .title-img {
        width: 3.923077rem;
        height: 1.32906rem;
        display: block;
        margin: 0 auto;
        margin-bottom: 0.08547rem;
        position: relative;
        z-index: 1;
        background: url("../assets/newldp/boxtop.png") no-repeat center/contain;
        .right-side {
          position: absolute;
          z-index: 0;
          top: 0.286325rem;
          right: -0.086667rem;
          width: 2.863248rem;
          height: 0.564103rem;
          display: flex;
          justify-content: flex-end;
          padding-right: 0.24547rem;
          align-items: center;
          background: url("../assets/newldp/boxtoprightside.png") no-repeat
            center/contain;
          .left {
            margin-right: 0.08547rem;
          }
          .left,
          .right {
            width: 0.897436rem;
            display: flex;
            align-items: center;
            cursor: pointer;
            img {
              width: 100%;
            }
          }
        }
      }
      .banner-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        img {
          width: 1.589744rem;
        }
      }
      .banner-text-box {
        font-family: Montserrat;
        font-size: 0.066667rem;
        line-height: 0.081481rem;
        text-align: left;
        color: #fff;
        span {
          color: #00ffec;
        }
        h1 {
          text-align: left;
          font-family: Montserrat;
          font-size: 0.066667rem;
          font-weight: 700;
          line-height: 0.081481rem;
          color: #00ffec;
        }
      }
      .banner-center {
        width: 4.42963rem;
        margin: 0.17094rem auto;
        display: block;
      }
      .rule-box {
        width: 100%;
        height: 2.179487rem;
        display: flex;
        flex-direction: column;
        font-size: 0.076923rem;
        color: #fff;
        text-align: left;
        gap: 0.042735rem;
        overflow: auto;
        margin-bottom: 0.17094rem;
        &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 3px;
          background: rgba(0, 0, 0, 0.06);
          -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
        }
        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          border-radius: 3px;
          background: rgba(0, 0, 0, 0.12);
          -webkit-box-shadow: inset 0 0 10px #00ffec;
        }

        .big-title-new {
          font-family: Montserrat;
          font-size: 0.19rem;
          font-weight: 400;
          line-height: 0.23rem;
          text-align: left;
          color: #00ffec;
        }

        .big-title {
          font-family: Montserrat;
          font-size: 0.102564rem;
          font-weight: 400;
          line-height: 0.094017rem;
          text-align: left;
        }
        .h1 {
          font-family: Montserrat;
          font-size: 0.076923rem;
          font-weight: 400;
          line-height: 0.094017rem;
          text-align: left;
          margin: 0;
          span {
            color: #00ffec;
          }
        }
        span {
          color: #00ffec;
        }
        ul {
          padding-left: 0.08547rem;
          margin: 0;
          li {
            list-style: disc;
            line-height: 0.094017rem;
            &.ano-li::marker {
              color: #fff;
              font-size: 0.05208rem;
            }
            &::marker {
              color: #00ffec;
              font-size: 0.05208rem;
            }
          }
        }
        .img-1 {
          width: 1.769231rem;
          display: block;
          margin: 0.064103rem auto;
        }
        .end-link {
          font-family: Montserrat;
          font-size: 0.08547rem;
          font-weight: 600;
          line-height: 0.102564rem;
          text-align: left;
          color: #00ffec;
        }
      }
    }

    .footer-1 {
      width: 100%;
      background: url("../assets/newldp/footer1.png") no-repeat center/contain;
      height: 2.241026rem;
      position: relative;
      .loginbtn {
        width: 1.559829rem;
        height: 0.34rem;
        position: absolute;
        bottom: 0.2rem;
        right: 1.36rem;
        cursor: pointer;
      }
    }

    .footer {
      width: 100%;
      display: block;
    }

    .form-content {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;
      flex-flow: column;
      align-items: center;
      position: relative;
      .dialogtitle {
        margin-bottom: -0.07949rem;
        width: 2.696581rem;
      }
      .tabs {
        display: flex;
        width: 2.696581rem;
        .left {
          margin-right: 0.042735rem;
        }
        .left,
        .right {
          cursor: pointer;
          flex: 1;
          img {
            width: 100%;
          }
        }
      }
      .form {
        display: flex;
        width: 2.713675rem;
        padding-top: 0.08547rem;
        background-size: 100% 100%;
        box-sizing: border-box;
        position: relative;

        /deep/ .el-form-item {
          margin-bottom: 35px;
        }
        .icon-box {
          position: absolute;
          bottom: 102px;
          text-align: center;
          width: 320px;
          img {
            margin-right: 23px;
          }
        }
        .codeImg {
          cursor: pointer;
          width: 0.641026rem;
          height: 0.213675rem;
          position: absolute;
          right: 0;
          top: 1px;
          .img {
            width: 0.641026rem;
            height: 0.213675rem;
            border-radius: 20px;
            display: block;
          }
        }
        /deep/ .el-form-item__error {
          color: #f7bd00;
        }
        .tags {
          width: 100%;
          height: 70px;
          position: relative;
          top: 15%;
          z-index: 99;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-family: "Montserrat";
          font-size: 20px;
          color: #ffffff;

          .tag {
            width: 55%;
            height: 100%;
            line-height: 3;
            text-indent: 3em;
            cursor: pointer;
            position: relative;

            &:nth-child(1) {
              background-image: url("../assets/jump/bgi-tag-left.png");
              background-size: 100% 100%;

              &.active {
                background-image: url("../assets/jump/bgi-tag-left-active.png");
              }
            }

            &:nth-child(2) {
              text-indent: 5em;
              background-image: url("../assets/jump/bgi-tag-right.png");
              background-size: 100% 100%;

              &.active {
                background-image: url("../assets/jump/bgi-tag-right-active.png");
              }
            }
          }
        }
        .inputs {
          width: 100%;
          background-size: 100% 100%;
          display: flex;
          flex-flow: column;
          justify-content: flex-start;
          align-items: center;
          box-sizing: border-box;
          position: relative;
        }

        .form-input {
          width: 100%;
          height: 0.213675rem;
          display: flex;
          position: relative;
          &.verificationCode {
            width: 1.923077rem;
          }
          input {
            width: 100%;
            height: 100%;
            background: #001519;
            border-radius: 0.042735rem;
            border: none;
            outline: none;
            text-indent: 0.08547rem;
            font-size: 0.068376rem;
            color: #fff;
            &::placeholder {
              color: #fff;
              font-size: 0.068376rem;
            }
          }
        }

        a.error {
          display: block;
          margin: 20px;
          color: #ffffff;
          font-size: 20px;
          text-decoration: none;
        }

        .submitBtn {
          width: 2.692308rem;
          height: 0.213675rem;
          background-image: url("../assets/newldp/regiserbtn.png");
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: Montserrat-Black;
          font-size: 23px;
          color: #ffffff;
          cursor: pointer;
          position: absolute;
          bottom: -0.15547rem;
          transform: translateX(-50%);
          background-size: 100% 100%;
          &.login {
            background-image: url("../assets/newldp/loginbtn.png");
            transform: none;
          }
        }
      }
    }

    /deep/ .mask-layer .modal .close-img {
      top: -32px;
      right: -32px;
      position: absolute;
      cursor: pointer;
    }
  }
}

.root {
  width: 100vw;
  min-height: 100vh;
  background-image: url("../assets/newldp/h5Bg.png");
  margin: 0;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  align-items: center;
  color: #ffffff;
  overflow: auto;
  .swiper-container {
    width: 100%;
  }
  .title-box {
    width: 100%;
    height: 0.76rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.09rem;
    margin-top: 0.13rem;
    .img-box {
      width: 1.55rem;
    }
  }

  .fixed-bottom-left {
    position: fixed;
    bottom: 0;
    width: 3.24rem;
    cursor: pointer;
    left: 0;
    img {
      width: 100%;
    }
    i {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 0.2rem;
      color: #fff;
    }
  }

  .fixed-bottom-right {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 0.7rem;
    height: 2.3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      display: block;
    }
  }

  .content-box {
    width: 6.7rem;
    margin: 0 auto;
    text-align: center;
    .top-side {
      width: 6.7rem;
      height: 1.32rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background: url("../assets/newldp/boxtoprightside.png") no-repeat
        center/contain;
      padding-right: 0.27rem;
      margin-bottom: 0.4rem;
      .left {
        margin-right: 0.08547rem;
      }
      .left,
      .right {
        width: 2.1rem;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
    }
    .title-img {
      width: 5.88rem;
      display: block;
      margin: 0 auto;
      margin-bottom: 0.4rem;
    }
    .banner-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 0.4rem;
      img {
        width: 3.25rem;
      }
    }
    .banner-text-box {
      font-family: Montserrat;
      font-size: 0.19rem;
      line-height: 0.23rem;
      text-align: left;
      color: #fff;
      span {
        color: #00ffec;
      }
      h1 {
        text-align: left;
        font-family: Montserrat;
        font-size: 0.19rem;
        line-height: 0.23rem;
        font-weight: 700;
        color: #00ffec;
      }
    }
    .banner-center {
      width: 100%;
      margin: 0.15rem auto;
      display: block;
    }
    .rule-box {
      width: 100%;
      height: 2.179487rem;
      display: flex;
      flex-direction: column;
      font-size: 0.18rem;
      color: #fff;
      text-align: left;
      gap: 0.2rem;
      overflow: auto;
      margin-bottom: 0.17094rem;
      &::-webkit-scrollbar {
        width: 0.08rem;
        height: 0.7rem;
      }
      &::-webkit-scrollbar-track {
        border-radius: 3px;
        background: rgba(0, 0, 0, 0.06);
        -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
      }
      /* 滚动条滑块 */
      &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: rgba(0, 0, 0, 0.12);
        -webkit-box-shadow: inset 0 0 10px #00ffec;
      }

      .big-title {
        font-family: Montserrat;
        font-size: 0.19rem;
        font-weight: 400;
        line-height: 0.23rem;
        text-align: left;
      }
      .h1 {
        font-family: Montserrat;
        font-size: 0.19rem;
        font-weight: 400;
        line-height: 0.23rem;
        text-align: left;
        margin: 0;
        span {
          color: #00ffec;
        }
      }
      span {
        color: #00ffec;
      }
      ul {
        padding-left: 0.08547rem;
        margin: 0;
        li {
          list-style: disc;
          line-height: 0.23rem;
          &.ano-li::marker {
            color: #fff;
            font-size: 0.05208rem;
          }
          &::marker {
            color: #00ffec;
            font-size: 0.05208rem;
          }
        }
      }
      .img-1 {
        width: 4.14rem;
        display: block;
        margin: 0.15rem auto;
      }
      .end-link {
        font-family: Montserrat;
        font-size: 0.08547rem;
        font-weight: 600;
        line-height: 0.102564rem;
        text-align: left;
        color: #00ffec;
      }
    }
  }
  /deep/ .el-form-item__content {
    display: flex;
  }

  .form-content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-flow: column;
    align-items: center;
    position: relative;
    .dialogtitle {
      margin-bottom: -0.07949rem;
      width: 6.31rem;
    }
    .tabs {
      display: flex;
      width: 6.31rem;
      height: 0.45rem;
      .left {
        margin-right: 0.042735rem;
      }
      .left,
      .right {
        cursor: pointer;
        display: flex;
        flex: 1;
        img {
          width: 100%;
        }
      }
    }
    .form {
      display: flex;
      width: 6.31rem;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding-top: 0.2rem;
      padding-bottom: 1rem;
      /deep/ .el-form-item {
        margin-bottom: 35px;
      }
      .icon-box {
        position: absolute;
        bottom: 102px;
        text-align: center;
        width: 320px;
        img {
          margin-right: 23px;
        }
      }
      .codeImg {
        cursor: pointer;
        width: 1.7rem;
        height: 0.5rem;
        position: absolute;
        right: 0;
        .img {
          width: 1.7rem;
          height: 0.5rem;
          border-radius: 0.1rem;
        }
      }
      /deep/ .el-form-item__error {
        color: #f7bd00;
      }
      .tags {
        width: 100%;
        height: 70px;
        position: relative;
        top: 15%;
        z-index: 99;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: "Montserrat";
        font-size: 20px;
        color: #ffffff;

        .tag {
          width: 55%;
          height: 100%;
          line-height: 3;
          text-indent: 3em;
          cursor: pointer;
          position: relative;

          &:nth-child(1) {
            background-image: url("../assets/jump/bgi-tag-left.png");
            background-size: 100% 100%;

            &.active {
              background-image: url("../assets/jump/bgi-tag-left-active.png");
            }
          }

          &:nth-child(2) {
            text-indent: 5em;
            background-image: url("../assets/jump/bgi-tag-right.png");
            background-size: 100% 100%;

            &.active {
              background-image: url("../assets/jump/bgi-tag-right-active.png");
            }
          }
        }
      }
      .inputs {
        width: 100%;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        position: relative;
      }

      .form-input {
        width: 100%;
        height: 0.5rem;
        display: flex;
        position: relative;
        &.verificationCode {
          width: 4.5rem;
        }
        input {
          width: 100%;
          height: 100%;
          background: #001519;
          border-radius: 0.042735rem;
          border: none;
          outline: none;
          text-indent: 0.08547rem;
          font-size: 0.16rem;
          color: #fff;
          &::placeholder {
            color: #fff;
            font-size: 0.16rem;
          }
        }
      }

      a.error {
        display: block;
        margin: 20px;
        color: #ffffff;
        font-size: 20px;
        text-decoration: none;
      }

      .submitBtn {
        width: 6.3rem;
        height: 0.5rem;
        background-image: url("../assets/newldp/regiserbtn.png");
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: Montserrat-Black;
        font-size: 23px;
        color: #ffffff;
        cursor: pointer;
        position: absolute;
        bottom: -0.35547rem;
        background-size: 100% 100%;
        transform: translateX(-50%);
        background-repeat: no-repeat;
        &.login {
          background-image: url("../assets/newldp/loginbtn.png");
          transform: none;
        }
      }
    }
  }
  .codeImg {
    cursor: pointer;
    width: 3.8rem;
    height: 1.4rem;
    display: flex;
    text-align: right;
    .validateCode {
      width: 3.8rem;
      display: flex;

      .img {
        border-radius: 0.4rem;
        width: 3.8rem;
        height: 1.4rem;
        transform: none !important;
        position: unset !important;
      }
    }
  }
  .footer-1 {
    width: 100%;
    height: 6.1rem;
    background: url("../assets/newldp/h5footer1.png") no-repeat center/contain;
    position: relative;
    .loginbtn {
      width: 3.65rem;
      height: 0.84rem;
      position: absolute;
      bottom: 0.88rem;
      right: 0.56rem;
    }
  }
  .footer {
    width: 100%;
    display: block;
  }

  .next-btn {
    right: 0;
    width: 67px;
    height: 67px;
    background-image: url("../assets/Ldp/chevron-right.svg");
  }

  .prev-btn {
    left: 0;
    width: 67px;
    height: 67px;
    background-image: url("../assets/Ldp/chevron-left.svg");
    cursor: pointer;
  }

  .nav-btn {
    position: absolute;
    top: calc(50% - 33.5px);
    z-index: 3;
    cursor: pointer;
  }

  ::-ms-input-placeholder {
    font-size: 1.2em;
  }

  ::-webkit-input-placeholder {
    font-size: 1.2em;
  }
}
/deep/ .el-form-item {
  width: 100%;
}
/deep/ .geetest_box_wrap .geetest_box {
  top: -159px;
}
</style>



// WEBPACK FOOTER //
// src/components/newldp.vue